/**
 * Created by root on 9/11/16.
 */
define(function (require) {

    var BaseController = require('web-agent-assets-js/BaseController');

    // TODO: in theory, the adapter can aggregate multiple services, but for simplicity sake for now, we are only support 1 to 1 relation
    // between the adapter and the service.
    // in general, we can wrap a list of services into one service and then adapt it.. this is also a way..

    var BaseAdapter = BaseController.extend(function lpBaseAdapter(options) {
        this.service = (options && options.service);
    });

    return BaseAdapter;

});
